module.exports = __webpack_public_path__ + "media/images/flags/4x3/cym-63d8f29557f58e55b4a4cb83ca493032.svg";